const strings = {
  CANCEL: {
    SE: 'Avbryt',
    EN: 'Cancel'
  },
  DONE: {
    SE: 'Klar',
    EN: 'Done'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/common/TwoInputModal/strings.js